export default __webpack_public_path__ + "static/media/Miele Logo2.7eb277ba.svg";